// Cache-Control max-age (seconds) applied to avatar uploads (30 days).
// Avatars rarely change; aggressive caching reduces re-fetches on every render.
export const AVATAR_CACHE_CONTROL_SECONDS = '2592000';
